import cloudLogo from '@/asserts/images/logo/logo-cloud.svg';
import flexibleLogo from '@/asserts/images/logo/logo-flexibleCode.svg';
import ifbook from '@/asserts/images/logo/logo-ifbook.svg';
import qtaifbook from '@/asserts/images/logo/logo-qta-ifbook.svg';
import { PLATFORM } from '@/common/constants/platform-constants';

export const SiteLogo = {
  [PLATFORM.STANDALONE]: [
    {
      key: 'cloud',
      img: cloudLogo,
      href: '/',
    },

    {
      key: 'ifbook',
      img: qtaifbook,
      href: '/',
    },
  ],
  [PLATFORM.STANDALONE_WOA]: [
    {
      key: 'cloud',
      img: cloudLogo,
      href: '/',
    },
    {
      key: 'flexible',
      img: flexibleLogo,
      href: 'https://flexiblecode.woa.com/',
    },
    {
      key: 'ifbook',
      img: ifbook,
      href: '/',
    },
  ],
};
